//= Functions & Modules
// Others
import { createRoot } from 'react-dom/client';
import React from 'react';

//= React components
// Own
import { App } from './App';
// Others
import { BrowserRouter } from 'react-router-dom';

const root = createRoot(document.getElementById('main')!);
root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);
